import getProjectRoute from "./get-project-route";
import listProjectsRoute from "./list-projects-route";
import updateProjectStatusRoute from "./set-project-status-route";
import setProjectDeliverablesCompletionRoute from "./set-project-deliverables-completion-route";

export default {
  "get-project": getProjectRoute,
  "list-projects": listProjectsRoute,
  "set-project-status": updateProjectStatusRoute,
  "set-project-deliverables-completion": setProjectDeliverablesCompletionRoute,
};
